import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAInitialState, PAStateTypes } from './pa.state.ts';
import { fetchPADataSet } from 'store/feature/pa/pa.thunk.ts';
import { QueryState } from '@/common/enum';
import { PAData } from 'interfaces/pa.interface.ts';
import {
  LegendTypes,
  MarkerTypeWithoutIcon,
} from 'pages/MapPage/components/ModalLegends/Constants.tsx';

const initialState: PAStateTypes = PAInitialState;

export const paSlice = createSlice({
  name: 'pa',
  initialState,
  reducers: {
    setCurrentPAEntry: (state, action: PayloadAction<PAData | null>) => {
      state.currentEntry = action.payload;
    },
    setCurrentPATitle: (state, action: PayloadAction<string>) => {
      state.paTitle = action.payload;
    },
    updatePADataSet: (state, action: PayloadAction<PAData[]>) => {
      if (!state.paDataset) return;
      state.paDataset.dataset = action.payload;
    },
    updateMapLegendTypes: (state, action: PayloadAction<MarkerTypeWithoutIcon[]>) => {
      state.mapLegendTypes = action.payload;
    },
    setAllCheckedTypes: (state, action: PayloadAction<boolean>) => {
      state.allCheckedTypes = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPADataSet.pending, (state) => {
        state.queryState = QueryState.AWAIT;
        state.error = null;
      })
      .addCase(fetchPADataSet.fulfilled, (state, action) => {
        state.queryState = QueryState.READY;
        state.paDataset = action.payload ?? null;
        if (state.paDataset && action.payload?.dataset) {
          state.originalDataset = action.payload.dataset;
          if (!action.meta.arg?.keepLegend) {
            state.allCheckedTypes = true;
            state.mapLegendTypes = LegendTypes.map(({ icon, ...rest }) => rest);
          } else if (state.mapLegendTypes.some((legend) => !legend.checked)) {
            // *: Same match as the legend's own filter (SuffixButtons handleCBLegendTypes).
            const legends = state.mapLegendTypes;
            state.paDataset.dataset = action.payload.dataset.filter(
              (item) =>
                legends.find((legend) => legend.subTitle === `Category ${item.category}`)
                  ?.checked ?? false
            );
          }
        }
      })
      .addCase(fetchPADataSet.rejected, (state, action) => {
        state.queryState = QueryState.FAIL;
        state.error = action.error.message ?? 'Something went wrong!';
      });
  },
});

export const {
  setCurrentPAEntry,
  setCurrentPATitle,
  updatePADataSet,
  updateMapLegendTypes,
  setAllCheckedTypes,
} = paSlice.actions;

export default paSlice.reducer;
